export default __webpack_public_path__ + "static/media/map-marker-selected.b41a5c0d.svg";